var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "4", lg: "4" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function($event) {
                      _vm.dialog = true
                    }
                  }
                },
                [_vm._v("Add Rig")]
              ),
              _vm._v(" "),
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.rigs,
                  expanded: _vm.expandedRigs,
                  "item-key": "name",
                  "show-expand": "",
                  "items-per-page": 20
                },
                on: {
                  "update:expanded": function($event) {
                    _vm.expandedRigs = $event
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.upcoming_inspection",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        item.upcoming_inspection
                          ? _c("span", [
                              _vm._v(
                                _vm._s(
                                  new Date(
                                    item.upcoming_inspection
                                  ).toLocaleString("en-AU", {
                                    timeZone: "UTC",
                                    year: "numeric",
                                    month: "short",
                                    day: "numeric"
                                  })
                                )
                              )
                            ])
                          : _vm._e()
                      ]
                    }
                  },
                  {
                    key: "expanded-item",
                    fn: function(ref) {
                      var headers = ref.headers
                      var item = ref.item
                      return [
                        _c(
                          "td",
                          {
                            staticClass: "expanded-actions",
                            attrs: { colspan: headers.length }
                          },
                          [
                            _c("v-switch", {
                              attrs: {
                                disabled:
                                  item.components.length <
                                    _vm.componentTypes.length &&
                                  item.status == 0,
                                success: item.status == 1 ? true : false,
                                inset: "",
                                label: _vm.getSwitchLabel(item.status)
                              },
                              on: {
                                change: function($event) {
                                  return _vm.updateRigStatus(item)
                                }
                              },
                              model: {
                                value: item.status,
                                callback: function($$v) {
                                  _vm.$set(item, "status", $$v)
                                },
                                expression: "item.status"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                staticClass: "blue--text",
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.reset(item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { center: "" } }, [
                                  _vm._v("mdi-update")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "", small: "" },
                                on: {
                                  click: function($event) {
                                    return _vm.edit(item)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { center: "" } }, [
                                  _vm._v("mdi-pencil")
                                ])
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "v-btn",
                              {
                                attrs: {
                                  disabled: item.status == 1,
                                  icon: "",
                                  small: "",
                                  color: "red"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.deleteRig(item.id)
                                  }
                                }
                              },
                              [
                                _c("v-icon", { attrs: { center: "" } }, [
                                  _vm._v("mdi-delete-forever")
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "8", lg: "8" } },
            [_c("ComponentForm", { on: { showSnack: _vm.showSnack } })],
            1
          ),
          _vm._v(" "),
          _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "98%" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-card",
                { attrs: { color: "lighten-1" } },
                [
                  _c(
                    "v-toolbar",
                    [
                      _c("v-toolbar-title", [
                        _c("span", { staticClass: "headline" }, [
                          _vm._v(_vm._s(_vm.formTitle))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-form",
                        {
                          ref: "form",
                          staticClass: "row",
                          model: {
                            value: _vm.valid,
                            callback: function($$v) {
                              _vm.valid = $$v
                            },
                            expression: "valid"
                          }
                        },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "3", md: "3" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  rules: _vm.req,
                                  label: "Number/Reference",
                                  required: ""
                                },
                                model: {
                                  value: _vm.editedItem.name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "name", $$v)
                                  },
                                  expression: "editedItem.name"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm._l(_vm.componentTypes, function(type) {
                            return _c(
                              "v-col",
                              { key: type.id, attrs: { cols: "3", md: "3" } },
                              [
                                _vm.editedIndex === -1
                                  ? _c(
                                      "div",
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            disabled:
                                              _vm.getAvailableByType(type.id)
                                                .length == 0,
                                            items: _vm.getAvailableByType(
                                              type.id
                                            ),
                                            "item-text": "name",
                                            "item-value": "id",
                                            label: type.name,
                                            value:
                                              _vm.selComponents[type.fieldName]
                                          },
                                          model: {
                                            value:
                                              _vm.selComponents[type.fieldName],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selComponents,
                                                type.fieldName,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selComponents[type.fieldName]"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c("v-select", {
                                          attrs: {
                                            disabled:
                                              _vm.getChangeComponentOptions(
                                                type.id
                                              ).length == 0,
                                            items: _vm.getChangeComponentOptions(
                                              type.id
                                            ),
                                            "item-text": "name",
                                            "item-value": "id",
                                            label: type.name
                                          },
                                          model: {
                                            value:
                                              _vm.selComponents[type.fieldName],
                                            callback: function($$v) {
                                              _vm.$set(
                                                _vm.selComponents,
                                                type.fieldName,
                                                $$v
                                              )
                                            },
                                            expression:
                                              "selComponents[type.fieldName]"
                                          }
                                        })
                                      ],
                                      1
                                    )
                              ]
                            )
                          })
                        ],
                        2
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "blue darken-1", text: "" },
                          on: { click: _vm.close }
                        },
                        [_vm._v("Cancel")]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            color: "blue darken-1",
                            type: "submit",
                            disabled: !_vm.valid
                          },
                          on: { click: _vm.save }
                        },
                        [_vm._v("Save")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function(ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "orange", text: "" },
                        on: {
                          click: function($event) {
                            _vm.snackbar = false
                          }
                        }
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v("\n                    Close\n                  ")]
                  )
                ]
              }
            }
          ]),
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _vm._v(
            "\n                " +
              _vm._s(_vm.snackbartext) +
              " \n\n                "
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }